module.exports = __webpack_public_path__ + "static/media/soils_reports_3.7c819899.png";


//////////////////
// WEBPACK FOOTER
// ./public/stem_soils_images/soils_reports_3.png
// module id = 1290
// module chunks = 0